export interface AuthTokenDecoded {
    sub: string;
    unique_name?: string;
    roles?: Array<string>;
}

export enum AuthMode {
    NONE = "none",
    MS_ENTRA = "ms-entra",
    BASIC = "basic",
}
